define(function (require) {
    var _ = require("underscore");
    var $ = require("jquery");

    var sortByRef = function (ref, a, b) {
        if (a[ref] < b[ref]) return -1;
        if (a[ref] > b[ref]) return 1;
        return 0;
    };

    var propertySort = function (a, b, propToSortOn, ascending) {
        var nameA = a[propToSortOn]().toString().toUpperCase(); // ignore upper and lowercase
        var nameB = b[propToSortOn]().toString().toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
            return ascending ? -1 : 1;
        }
        if (nameA > nameB) {
            return ascending ? 1 : -1;
        }
        // names must be equal
        return 0;
    };

    return {
        emptyFilters: function (filterArray) {
            for (var i in filterArray) {
                if (filterArray.hasOwnProperty(i)) {
                    if (filterArray[i]() instanceof Array) {
                        filterArray[i]([]);
                    } else {
                        filterArray[i]("");
                    }
                }
            }
        },

        resetFiltersToDefaults: function (filterArray, defaultParameters) {
            for (var i in filterArray) {
                try {
                    if (filterArray.hasOwnProperty(i) && defaultParameters[i]) {
                        filterArray[i](defaultParameters[i]);
                    } else {
                        // filter item is not in defaultParameters
                        if (Array.isArray(filterArray[i]())) {
                            filterArray[i]([]); // set to empty array
                        } else {
                            filterArray[i]("");
                        }
                    }
                } catch (e) {
                    console.error("Error in resetFiltersToDefaults on " + i);
                    console.error(e.message);
                }
            }
        },

        filtersHaveNonDefaultValues: function (filterArray, defaultParameters) {
            for (var i in filterArray) {
                if (filterArray.hasOwnProperty(i)) {
                    // Need to check for Arrays since default [] is not the same as a ko.observable array
                    if (filterArray[i]() instanceof Array && filterArray[i]().length && (!defaultParameters[i] || (defaultParameters[i] && filterArray[i]().length !== defaultParameters[i].length))) {
                        return true;
                    } else if (!(filterArray[i]() instanceof Array) && filterArray[i]() && filterArray[i]().length && (!defaultParameters[i] || filterArray[i]() !== defaultParameters[i])) {
                        return true;
                    }
                }
            }
            return false;
        },

        nonPrimaryFiltersApplied: function (urlParams, secondaryFilters) {
            for (var i in urlParams) {
                if (urlParams.hasOwnProperty(i) && urlParams[i] !== "" && secondaryFilters.hasOwnProperty(i)) {
                    return true;
                }
            }
            return false;
        },

        /*
         * Initializes the given KO view model.  Observable properties on the model are set to the values provided in the givenValues or defaultValues objects.
         * If a particular observable (that is included in the default values) is not listed in the given values, its default is used instead.
         *
         * model: The Knockout view model
         * givenValues: an object whose properties represent the given value for each observable.
         * defaultValues: an object whose properties represent the default value for each observable.
         * nonDefaultObservables: an array, expected to initially be empty, that is filled with the names of observables that are set to non-default values.
         * returns: boolean indicating whether any non-default values were included in the set of given values.
         */
        initializeFilters: function (model, givenValues, defaultValues, nonDefaultObservables) {
            var value;
            var usedNonDefaultParams = false;
            var unionOfParameters = $.extend({}, defaultValues, givenValues);
            for (var i in unionOfParameters) {
                if (unionOfParameters.hasOwnProperty(i)) {
                    if (givenValues.hasOwnProperty(i) && givenValues[i] !== defaultValues[i]) {
                        value = givenValues[i];
                        usedNonDefaultParams = true;
                        if (nonDefaultObservables && Array.isArray(nonDefaultObservables)) {
                            nonDefaultObservables.push(i);
                        }
                    } else {
                        value = defaultValues[i];
                    }

                    if (model[i] && {}.toString.call(model[i]) === "[object Function]") {
                        model[i](value);
                    } else {
                        console.log(i + " is not a parameter on this model");
                    }
                }
            }

            return usedNonDefaultParams;
        },

        recalculatePageNumbers: function (model) {
            var currentPage = parseInt(model.pageNumber(), 10);
            var totalPages = parseInt(model.pages(), 10);

            // Don't show the pagelist if their is only one page
            if (totalPages === 1) {
                return;
            }

            var newList = [];
            newList.push({
                isLink: true,
                pageNumber: 1
            });

            var previous = currentPage - 1;
            var next = currentPage + 1;
            var showPreviousTwoAsLinks = (currentPage === 4 || currentPage === totalPages) && currentPage - 2 > 1;
            var showNextTwoAsLinks = (currentPage === 1 || currentPage === totalPages - 3) && currentPage + 2 < totalPages;

            if (previous > 1) {
                if (previous > 3) {
                    newList.push({
                        isSpacer: true
                    });
                }

                if (showPreviousTwoAsLinks) {
                    newList.push({
                        isLink: true,
                        pageNumber: previous - 1
                    });
                }

                newList.push({
                    isLink: true,
                    pageNumber: previous
                });
            }

            if (currentPage !== 1 && currentPage !== totalPages) {
                newList.push({
                    isLink: true,
                    pageNumber: currentPage
                });
            }

            if (next < totalPages) {
                newList.push({
                    isLink: true,
                    pageNumber: next
                });

                if (showNextTwoAsLinks) {
                    newList.push({
                        isLink: true,
                        pageNumber: next + 1
                    });
                }

                if (next < totalPages - 2) {
                    newList.push({
                        isSpacer: true
                    });
                }
            }

            newList.push({
                isLink: true,
                pageNumber: totalPages
            });

            model.pageList(newList);
        },

        setPageNumber: function (model, pageObject) {
            model.pageNumber(parseInt(pageObject.pageNumber, 10));
            model.setFocusOnResults();
        },

        setFocusOnResults: function (selector) {
            if (!selector) {
                selector = ".lookup-tools-container-results";
            }
            setTimeout(function () {
                var $resultsContainer = $(selector),
                    offset = $resultsContainer.offset().top;
                $("html, body").animate({ scrollTop: offset }, 500, function () {
                    // add focus to anchor .attr("tabindex", "0")?
                    $resultsContainer.attr("tabindex", -1).focus();
                });
            }, 500);
        },

        sortDescendingByCount: function (a, b) {
            var optA = a.count;
            var optB = b.count;

            var comparison = 0;
            if (optA > optB) {
                comparison = 1;
            } else if (optA < optB) {
                comparison = -1;
            }
            return comparison * -1;
        },

        sortByName: function (a, b) {
            if ((!isNaN(a.Name) || !isNaN(b.Name)) && !(isNaN(a.Name) && isNaN(b.Name))) {
                // compare if one or the other is a number - this should move number to the end
                return !isNaN(a.Name) && isNaN(b.Name) ? 1 : -1;
            } else {
                return sortByRef("Name", a, b);
            }
        },
        sortByText: function (a, b) {
            return sortByRef("text", a, b);
        },

        mapFacets: function (result) {
            return _.map(result, function (item) {
                return { text: item.NameWithCount, value: item.Value, name: item.Name, count: item.Count };
            });
        },

        mapProperty: function (result, mapper, propThatMatchesMapper, propToOverride, includeCounts) {
            var newObj = {};
            return _.map(result, function (item) {
                newObj[propToOverride] = mapper[item[propThatMatchesMapper]];
                if (includeCounts) {
                    newObj[propToOverride] = newObj[propToOverride] + " (" + item.count + ")";
                }
                return $.extend(item, newObj);
            });
        },

        sortByProperty: function (propToSortOn, ascending) {
            ascending = typeof ascending !== "undefined" ? ascending : true;

            return function (a, b) {
                return propertySort(a, b, propToSortOn, ascending);
            };
        },

        // Takes an array of objects of { propName: value, ascendingOrder: true/false}
        sortByProperties: function (propsToSortOn) {
            return function (a, b) {
                for (var i = 0; i < propsToSortOn.length; i++) {
                    var index = propertySort(a, b, propsToSortOn[i].propName, propsToSortOn[i].ascendingOrder);
                    if (index !== 0) {
                        return index;
                    }
                }
                return 0;
            };
        },

        sortByDate: function (datePropToSortOn, ascending) {
            ascending = typeof ascending !== "undefined" ? ascending : true;

            return function (a, b) {
                var propA = a[datePropToSortOn]();
                var propB = b[datePropToSortOn]();

                if (!propA && !propB) {
                    return 0;
                }
                if (!propA) {
                    return ascending ? -1 : 1;
                }
                if (!propB) {
                    return ascending ? 1 : -1;
                }

                var dateA = new Date(propA);
                var dateB = new Date(propB);

                if (dateA < dateB) {
                    return ascending ? -1 : 1;
                }
                if (dateA > dateB) {
                    return ascending ? 1 : -1;
                }
                // names must be equal
                return 0;
            };
        },

        paginateArray: function (arr, pageSize, pageNumber) {
            --pageNumber;

            return arr.slice(pageNumber * pageSize, (pageNumber + 1) * pageSize);
        }
    };
});
